export const checkCompetition = (competitionName: string, competitionArray: Array<string>): boolean => {
    const chunks = competitionName.toLowerCase().split(' ');

    for (const item of competitionArray) {
        if (chunks.includes(item.toLowerCase())) {
            return true;
        }
    }
    return false;
};
